module.exports = __webpack_public_path__ + "static/img/wx-qr-code.806ed1e7.jpg";